var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecondVerificationErrorSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 38.4C30.162 38.4 38.4 30.162 38.4 20C38.4 9.83796 30.162 1.6 20 1.6C9.83796 1.6 1.6 9.83796 1.6 20C1.6 30.162 9.83796 38.4 20 38.4ZM20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0C8.95431 0 0 8.95431 0 20C0 31.0457 8.95431 40 20 40Z",
    fill: "#E26982"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4974 19.9992L26.8586 14.6381L25.3611 13.1406L20 18.5018L14.6389 13.1406L13.1414 14.6381L18.5025 19.9992L13.1414 25.3603L14.6389 26.8578L20 21.4967L25.3611 26.8578L26.8586 25.3603L21.4974 19.9992Z",
    fill: "#E26982"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3611 13.1406L26.8586 14.6381L21.4974 19.9992L26.8586 25.3603L25.3611 26.8578L20 21.4967L14.6389 26.8578L13.1414 25.3603L18.5025 19.9992L13.1414 14.6381L14.6389 13.1406L20 18.5018L25.3611 13.1406Z",
    fill: "#E26982"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondVerificationErrorSmall);
export default __webpack_public_path__ + "static/media/second-verification-error-small.e87a7250.svg";
export { ForwardRef as ReactComponent };